'use client';
export const loginMethods: (
	| 'email'
	| 'sms'
	| 'google'
	| 'wallet'
	| 'discord'
)[] = ['email', 'sms', 'google', 'wallet', 'discord'];

import { useEffect, useState } from 'react';

type LoginMethod = 'email' | 'sms' | 'wallet' | 'discord' | 'google';

export const useLoginMethods = () => {
	const [methods, setMethods] = useState<LoginMethod[]>([
		'email',
		'sms',
		'wallet',
		'discord',
		'google',
	]);

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const ua = navigator.userAgent;
		const isInstagram = /Instagram/i.test(ua);
		const isFacebook = /FBAN|FBAV/i.test(ua);

		if (isInstagram || isFacebook) {
			setMethods(['email', 'sms', 'wallet', 'discord']);
		}
	}, []);

	return methods;
};

export const useIsMetaInAppBrowser = () => {
	const [isMetaInAppBrowser, setIsMetaInAppBrowser] = useState(false);

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const ua = navigator.userAgent;
		const isInstagram = /Instagram/i.test(ua);
		const isFacebook = /FBAN|FBAV/i.test(ua);
        const isTelegram = /Telegram/i.test(ua) || 
                     /TelegramBot/i.test(ua) ||
                     !!(window as any).Telegram?.WebApp ||
                     !!(window as any).TelegramWebviewProxy;

		if (isInstagram || isFacebook || isTelegram) {
			setIsMetaInAppBrowser(true);
		}
	}, []);

	return isMetaInAppBrowser;
};
